const SwrKey = {
  USER: 'user',
  USERS: 'users',
  VIDEOS: 'videos',
  VIDEO_TAGS: 'video_tags',
  VIDEO_DETAIL: 'video_detail',
  SCENARIO_VIDEOS: 'scenario_videos',
  SCENARIOS: 'scenarios',
  SCENARIO: 'scenario',
  PUBLIC_SCENARIO: 'public_scenario',
  SCENARIO_DETAIL: 'scenario_detail',
  SCENARIO_VERSIONS: 'scenario_versions',
  SURVEYS: 'surveys',
  SURVEY: 'survey',
  ANALYTICS_SUMMARY: 'analytics_summary',
  ANALYTICS_TIMESERIES: 'analytics_timeseries',
  ANALYTICS_SESSIONS: 'analytics_sessions',
  ANALYTICS_OVERALL: 'analytics_overall',
  ANALYTICS_DETAILED_SESSIONS: 'analytics_detailed_sessions',
  ANALYTICS_SESSION_DETAIL: 'analytics_session_detail',
  ANALYTICS_BUTTON_CLICKS: 'analytics_button_clicks',
  ANALYTICS_SURVEY_REPORT: 'analytics_survey_report',
  ANALYTICS_JOURNEY: 'analytics_journey',
  TENANT_SURVEY_REPORT: 'tenant_survey_report',
  PERFORMER_TEMPLATES: 'performer_templates',
  VIDEO_TEXT_TEMPLATES: 'video_text_templates',
  TENANT: 'tenant',
  PUBLIC_TENANT: 'public_tenant',
  ACCESSIBLE_TENANTS: 'accessible_tenants',
  PLAN_USAGE: 'plan_usage',
  ADMIN_TENANTS: 'admin_tenants',
  ADMIN_USERS: 'admin_users',
  CV_SETTINGS: 'cv_settings',
  GA4_STATUS: 'ga4_status',
  GA4_TRAFFIC_SOURCES: 'ga4_traffic_sources',
  GA4_CONVERSIONS: 'ga4_conversions',
  GA4_VIDEO_ATTRIBUTION: 'ga4_video_attribution',
  GA4_VIEW_DEPTH_CONVERSION: 'ga4_view_depth_conversion',
  GA4_TRAFFIC_SOURCE_ANALYSIS: 'ga4_traffic_source_analysis',
  GA4_DEMOGRAPHICS: 'ga4_demographics',
  GA4_LANDING_PAGES: 'ga4_landing_pages',
  GA4_REGIONS: 'ga4_regions',
  REPORT_SUMMARY: 'report_summary',
  REPORT_SCENARIOS: 'report_scenarios',
  REPORT_VIDEO_PAGES: 'report_video_pages',
  REPORT_TIMESERIES: 'report_timeseries',
  REPORT_TYPE_BREAKDOWN: 'report_type_breakdown',
  REPORT_DEVICE_BREAKDOWN: 'report_device_breakdown',
  REPORT_VIDEO_FEEDBACK: 'report_video_feedback',
  REPORT_SCENARIO_VIDEO_BREAKDOWN: 'report_scenario_video_breakdown',
  REPORT_VIDEO_PLAYLIST_BREAKDOWN: 'report_video_playlist_breakdown',
  REPORT_VIDEO_PAGE_TIMESERIES: 'report_video_page_timeseries',
} as const

export type SwrKey = (typeof SwrKey)[keyof typeof SwrKey]

export default SwrKey
